import {
  Autocomplete,
  Chip,
  DialogActions,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import MaterialButton from "../../components/MaterialButton";
import { useState } from "react";
import Grid from "@mui/material/Grid2";

const AssetRequest = ({
  recruitmentdata,
  Allemail,
  setrecruitmentdata,
  handlerecruitmentchange,
  handleassertmail,
  setOpen,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " " || event.key === ",") {
      event.preventDefault();
      handleAddChip();
    }
  };

  const handleAddChip = () => {
    if (inputValue.trim() === "") return;
    const newOption = {
      label: inputValue.trim(),
      value: inputValue.trim().toLowerCase().replace(/\s+/g, "_"),
    };
    setrecruitmentdata((prev) => ({
      ...prev,
      assetcc: [...prev.assetcc, newOption],
    }));
    // setSelectedOptions((prev) => [...prev, newOption]);

    setInputValue("");
  };

  const checkAllField = () => {
    let allowSubmit = false;
    if (
      recruitmentdata?.assetNameStatus === "success" &&
      recruitmentdata?.assetchargeStatus === "success" &&
      recruitmentdata?.assetccStatus === "success" &&
      recruitmentdata?.remaindertimeStatus === "success" &&
      recruitmentdata?.ContentStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Asset Name <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            name="assetName"
            placeholder="eg.LAPTOP"
            value={recruitmentdata.assetName}
            onChange={(e) =>
              handlerecruitmentchange("assetName", e.target.value)
            }
            error={recruitmentdata.assetNameStatus === "error"}
            success={recruitmentdata.assetNameStatus === "success"}
            size="small"
          />
          {recruitmentdata.assetNameStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                {" "}
                Asset Name should be contain only alphabets{" "}
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Asset In charge <span style={{ color: "red" }}>*</span>
          </Typography>

          <MaterialSelect
            name="assetcharge"
            value={recruitmentdata.assetcharge}
            onChange={(e) => handlerecruitmentchange("assetcharge", e)}
            error={recruitmentdata.assetchargeStatus === "error"}
            success={recruitmentdata.assetchargeStatus === "success"}
            size="small"
            options={Allemail.map((val) => {
              return {
                value: val.value,
                label: val.label,
              };
            })}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            CC <span style={{ color: "red" }}>*</span>
          </Typography>

          <Autocomplete
            multiple
            freeSolo
            name="assetcc"
            options={Allemail}
            getOptionLabel={(option) => option.label}
            value={recruitmentdata?.assetcc}
            onChange={(e, value) => handlerecruitmentchange("assetcc", value)}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            filterSelectedOptions
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={handleKeyDown}
                size="small"
              />
            )}
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip
                  key={option.value}
                  label={option.label}
                  {...getTagProps({ index })}
                />
              ))
            }
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Reminder Time <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            name="remaindertime"
            type="time"
            value={recruitmentdata.remaindertime}
            onChange={(e) =>
              handlerecruitmentchange("remaindertime", e.target.value)
            }
            error={recruitmentdata.remaindertimeStatus === "error"}
            success={recruitmentdata.remaindertimeStatus === "success"}
            size="small"
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Reminder Content <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            name="Content"
            multiline
            rows={3.5}
            value={recruitmentdata.assetcontent}
            error={recruitmentdata.ContentStatus === "error"}
            success={recruitmentdata.ContentStatus === "success"}
            onChange={(e) =>
              handlerecruitmentchange("assetcontent", e.target.value)
            }
            size="small"
          />
        </Grid>
      </Grid>

      <DialogActions sx={{ justifyContent: "center" }}>
        <MaterialButton
          onClick={() => setOpen(false)}
          variant="gradient"
          color="dark"
          size="small"
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          disabled={!checkAllField()}
          variant="gradient"
          color="dark"
          onClick={handleassertmail}
          size="small"
        >
          Submit
        </MaterialButton>
      </DialogActions>
    </>
  );
};

export default AssetRequest;
